module.exports = __webpack_public_path__ + "348ae29e6fdde8f51b022bd2eead5920.MP3";